import { OrderDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { ConfirmationModal } from '../../../../../ui/components/pure/modal-content/confirmation-modal.component';
import { useConfirmationAction } from '../../../../hooks/confirmation-action.hook';
import { useMutationCancelOrder } from '../../order-details.queries';

export function CancelOrderModal({
  order,
  onAbort,
  onSuccess
}: {
  order: OrderDto;
  onAbort(): void;
  onSuccess(): void;
}) {
  const { onConfirm, state } = useConfirmationAction({
    mutationHook: useMutationCancelOrder,
    mutationArgs: { retailerID: order.retailer.id, orderID: order.id },
    onSuccess,
    modalCloseDelay: 300,
    overrideErrorMessage: 'There was an error cancelling the order'
  });

  return (
    <ConfirmationModal
      title="Cancel order?"
      content={['Cancelling will prevent you from delivering the order, but can be undone. Are you sure?']}
      isLoading={state.isLoading}
      onCancel={onAbort}
      onConfirm={onConfirm}
      actionButton={{
        label: 'Cancel Order',
        color: 'danger'
      }}
      cancelButton={{
        label: 'No'
      }}
    />
  );
}
